import { TextField } from "@mui/material";
import { ILoginProps, ILoginSubmit, ILoginTab } from "./ILoginProps"
import Utils from "../../portlibs/PortUtils";

export default function LoginTab(props:ILoginTab&ILoginProps&ILoginSubmit){
    if (props.tab==0) {
        return <div role="tabpanel" id="email">
            <TextField label="E-mail" variant="standard" value={props.email} onChange={(e:any)=>props.setEmail(e.target.value)} {...Utils.disableAutoComplete}/>
            <TextField label="Password" variant="standard" value={props.password} onChange={(e:any)=>props.setPassword(e.target.value)} type="password" autoComplete="current-password"/>
        </div>
    }
    else return <></>
}